// Import package components
import { useContext, useEffect, useMemo } from "react";
import { useLocation } from "react-router-dom";
import {
  Image,
  Navbar,
  NavbarContainer,
  NavbarDropdown,
  NavbarSticky,
  NavItem,
  Badge,
} from "uikit-react";
import UIkit from "uikit";
import { Link as RawLink } from "../ui-kit/Link";
import { AppContexts } from "../../providers";
import FEATURES from "../../config/features";

import Notification from "./notification";
import TrialAccount from "../common/TrialAccount";

const Link = ({ onClick, ...props }) => (
  <RawLink
    onClick={() => {
      onClick && onClick();
    }}
    {...props}
  />
);

const Header = (props) => {
  const { user: account, inbox, logout } = useContext(AppContexts.AuthContext);
  const { newOrderCount, getNewOrderCount } = useContext(
    AppContexts.OrdersContext,
  );

  const location = useLocation();

  //const history = useHistory();

  const handleLogout = async () => {
    console.log("logging out");

    logout()
      .then(() => {
        console.log("Goodbye");
      })
      .catch((err) => {
        console.warn("Error logging out:", err);
      });
  };

  const profileImage = useMemo(() => {
    return (
      (account?.user?.attachments || []).find((a) => a.type === "image") || null
    );
  }, [account]);

  useEffect(() => {
    getNewOrderCount();
  }, []);

  const isActive = (paths) => {
    if (!Array.isArray(paths)) {
      paths = [paths];
    }
    return paths.some((path) => {
      const regex = new RegExp(`^${path}`);
      return regex.test(location.pathname);
    })
      ? "uk-active"
      : "";
  };

  const hasExtras = () => {
    return (account?.details?.product || "").split(",").includes("extras");
  };

  // const isOnboardingUser = () => {
  //   return account && account?.details?.type === 'onboarding';
  // }

  return (
    <>
      <NavbarSticky id="ruebarue-navbar">
        <NavbarContainer className="hms-navbar">
          <Link to="/" className={`hms-logo ${isActive("/")}`} id="nav_list">
            <Image src="/images/logo.svg" alt="logo" />
          </Link>
          {!!account && account?.details?.type !== "onboarding" && (
            <a
              id="navbar-collapse-toggler"
              className="uk-hidden@xl"
              data-uk-navbar-toggle-icon
              href="#"
              uk-toggle="target: #mobile-menu; animation: uk-animation-fade"
              aria-expanded="false"
            ></a>
          )}
          <div
            className="navbar-collapse"
            id="navbar_collapse"
          >
            {!!account && account?.details?.type !== "onboarding" && (
              <Navbar left>
                <NavItem className={isActive("/messages")}>
                  <Link to="/messages">
                    Messages {/*<span className="message-count">98</span>*/}
                  </Link>
                </NavItem>
                <NavItem className={isActive(["/guests"])}>
                  <Link to="/guests">Guests</Link>
                </NavItem>
                <NavItem className={isActive(["/contacts"])}>
                  <Link to="/contacts">Contacts</Link>
                </NavItem>
                {hasExtras() && (
                  <NavItem className={isActive(["/orders"])}>
                    <Link
                      className="hms-notification-badge hms-notification-badge-right"
                      to="/orders"
                    >
                      Orders
                      {+newOrderCount > 0 && (
                        <Badge
                          className="hms-notification-count"
                          count={+newOrderCount}
                        />
                      )}
                    </Link>
                  </NavItem>
                )}
                <NavItem
                  className={isActive([
                    "/scheduler",
                    "/extend-guest-stay",
                    "/alerts",
                    "/surveys",
                    "/saved-responses",
                    "/message-templates",
                    "/units",
                    "/macros",
                    "/chatbot-faqs",
                    "/unanswered-questions",
                  ])}
                >
                  <Link to="#">
                    Messaging <Image src="/images/nav-dropdown-arrow.svg" />
                  </Link>
                  <NavbarDropdown id="automate-dropdown">
                    <NavItem>
                      <Link
                        onClick={() => {
                          UIkit.dropdown("#automate-dropdown").hide(0);
                        }}
                        to="/scheduler"
                      >
                        Scheduler
                      </Link>
                    </NavItem>
                    <NavItem>
                      <Link
                        onClick={() => {
                          UIkit.dropdown("#automate-dropdown").hide(0);
                        }}
                        to="/extend-guest-stay"
                      >
                        Extend Stays
                      </Link>
                    </NavItem>
                    <NavItem>
                      <Link
                        onClick={() => {
                          UIkit.dropdown("#automate-dropdown").hide(0);
                        }}
                        to="/alerts"
                      >
                        Alerts
                      </Link>
                    </NavItem>
                    <NavItem>
                      <Link
                        onClick={() => {
                          UIkit.dropdown("#automate-dropdown").hide(0);
                        }}
                        to="/surveys"
                      >
                        Surveys
                      </Link>
                    </NavItem>
                    <NavItem className="uk-nav-divider"></NavItem>
                    <NavItem>
                      <Link
                        onClick={() => {
                          UIkit.dropdown("#automate-dropdown").hide(0);
                        }}
                        to="/saved-responses"
                      >
                        Saved Responses
                      </Link>
                    </NavItem>
                    <NavItem>
                      <Link
                        onClick={() => {
                          UIkit.dropdown("#automate-dropdown").hide(0);
                        }}
                        to="/message-templates"
                      >
                        Message Templates
                      </Link>
                    </NavItem>
                  </NavbarDropdown>
                </NavItem>


                <NavItem
                  className={isActive(["/operations", "/tasks", "/operations/calender", "/operations/housekeeping", "/checklists", "/operations/rules"])}
                  >
                  <Link to="#">
                    Operations <Image src="/images/nav-dropdown-arrow.svg" />
                  </Link>
                  <NavbarDropdown id="tasks-dropdown">
                    <NavItem>
                      <Link
                        onClick={() => {
                          UIkit.dropdown("#tasks-dropdown").hide(0);
                        }}
                        to="/operations"
                      >
                        Dashboard
                      </Link>
                    </NavItem>                  
                    {FEATURES.CALENDAR_ENABLED && (
                    <NavItem>
                      <Link
                        onClick={() => {
                          UIkit.dropdown("#tasks-dropdown").hide(0);
                        }}
                        to="/operations/calender"
                      >
                        Calender
                      </Link>
                    </NavItem>
                    )}
                    {(FEATURES.HOUSEKEEPING_ENABLED || FEATURES.INSPECTIONS_ENABLED || FEATURES.MAINTENANCE_ENABLED) && (
                    <NavItem className="uk-nav-divider"></NavItem>
                    )}
                    {FEATURES.HOUSEKEEPING_ENABLED && (
                    <NavItem>
                      <Link
                        onClick={() => {
                          UIkit.dropdown("#tasks-dropdown").hide(0);
                        }}
                        to="/operations/housekeeping"
                      >
                        Housekeeping
                      </Link>
                    </NavItem>
                    )}
                    {FEATURES.INSPECTIONS_ENABLED && (
                    <NavItem>
                      <Link
                        onClick={() => {
                          UIkit.dropdown("#tasks-dropdown").hide(0);
                        }}
                        to="/operations/inspections"
                      >
                        Inspections
                      </Link>
                    </NavItem>
                    )}
                    {FEATURES.MAINTENANCE_ENABLED && (
                    <NavItem>
                      <Link
                        onClick={() => {
                          UIkit.dropdown("#tasks-dropdown").hide(0);
                        }}
                        to="/operations/maintenance"
                      >
                        Maintenance
                      </Link>
                    </NavItem>
                    )}
                    <NavItem>
                      <Link
                        onClick={() => {
                          UIkit.dropdown("#tasks-dropdown").hide(0);
                        }}
                        to="/work-orders"
                      >
                        Work Orders
                      </Link>
                    </NavItem>
                    {FEATURES.RULES_ENABLED && (
                    <>
                    <NavItem className="uk-nav-divider"></NavItem>
                    <NavItem>
                      <Link
                        onClick={() => {
                          UIkit.dropdown("#tasks-dropdown").hide(0);
                        }}
                        to="/operations/rules"
                      >
                        Rules
                      </Link>
                    </NavItem>
                    </>
                    )}
                    {(FEATURES.STORAGE_LOCATIONS_ENABLED || FEATURES.STORAGE_ITEMS_ENABLED || FEATURES.MANAGE_STOCK_ENABLED || FEATURES.STOCK_MOVEMENTS_ENABLED) && (
                    <>
                    <NavItem className="uk-nav-divider"></NavItem>
                    {FEATURES.STORAGE_LOCATIONS_ENABLED && (
                    <NavItem>
                      <Link
                        onClick={() => {
                          UIkit.dropdown("#tasks-dropdown").hide(0);
                        }}
                        to="/operations/storage/locations"
                      >
                        Storage Locations
                      </Link>
                    </NavItem>
                    )}
                    {FEATURES.STORAGE_ITEMS_ENABLED && (
                    <NavItem>
                      <Link
                        onClick={() => {
                          UIkit.dropdown("#tasks-dropdown").hide(0);
                        }}
                        to="/operations/storage/items"
                      >
                        Storage Items
                      </Link>
                    </NavItem>
                    )}
                    {FEATURES.MANAGE_STOCK_ENABLED && (
                    <NavItem>
                      <Link
                        onClick={() => {
                          UIkit.dropdown("#tasks-dropdown").hide(0);
                        }}
                        to="/operations/storage/stock"
                      >
                        Manage Stock
                      </Link>
                    </NavItem>
                    )}
                    {FEATURES.STOCK_MOVEMENTS_ENABLED && (
                    <NavItem>
                      <Link
                        onClick={() => {
                          UIkit.dropdown("#tasks-dropdown").hide(0);
                        }}
                        to="/operations/storage/movements"
                      >
                        Stock Movements
                      </Link>
                    </NavItem>
                    )}
                    <NavItem className="uk-nav-divider"></NavItem>
                    </>
                    )}                    
                    {FEATURES.HOME_INVENTORY_ENABLED && (
                    <NavItem>
                      <Link
                        onClick={() => {
                          UIkit.dropdown("#tasks-dropdown").hide(0);
                        }}
                        to="/operations/home-inventory"
                      >
                        Home Inventory
                      </Link>
                    </NavItem>
                    )}
                    {(FEATURES.HOME_INVENTORY_ENABLED || FEATURES.CLEANING_STANDARDS_ENABLED || FEATURES.PROPERTY_SETUP_ENABLED) && (
                    <NavItem className="uk-nav-divider"></NavItem>
                    )}                    
                    {FEATURES.CLEANING_STANDARDS_ENABLED && (
                    <NavItem>
                      <Link
                        onClick={() => {
                          UIkit.dropdown("#tasks-dropdown").hide(0);
                        }}
                        to="/operations/standards-structure"
                      >
                        Cleaning & Inspection Standards
                      </Link>
                    </NavItem>
                    )}
                    {FEATURES.PROPERTY_SETUP_ENABLED && (
                    <NavItem>
                      <Link
                        onClick={() => {
                          UIkit.dropdown("#tasks-dropdown").hide(0);
                        }}
                        to="/operations/property-setup"
                      >
                        Property Setup
                      </Link>
                    </NavItem>
                    )}

                    {FEATURES.CHECKLISTS_ENABLED && (
                    <NavItem>
                      <Link
                        onClick={() => {
                          UIkit.dropdown("#tasks-dropdown").hide(0);
                        }}
                        to="/operations/checklists"
                      >
                        Checklists
                      </Link>
                    </NavItem>
                    )}
                  </NavbarDropdown>
                </NavItem>                
                <NavItem>
                  <Link to="#">
                    Guest Guides <Image src="/images/nav-dropdown-arrow.svg" />
                  </Link>
                  <NavbarDropdown id="guide-dropdown">
                    <NavItem>
                      <Link
                        onClick={() => {
                          UIkit.dropdown("#guide-dropdown").hide(0);
                        }}
                        to="/master-home-guide"
                      >
                        Master Home Guide
                      </Link>
                    </NavItem>
                    <NavItem>
                      <Link
                        onClick={() => {
                          UIkit.dropdown("#guide-dropdown").hide(0);
                        }}
                        to="/properties"
                      >
                        Home Guides
                      </Link>
                    </NavItem>
                    {hasExtras() && (
                      <NavItem>
                        <Link
                          onClick={() => {
                            UIkit.dropdown("#guide-dropdown").hide(0);
                          }}
                          to="/extras"
                        >
                          Extras Guide
                        </Link>
                      </NavItem>
                    )}
                    <NavItem>
                      <Link
                        onClick={() => {
                          UIkit.dropdown("#guide-dropdown").hide(0);
                        }}
                        to="/areas"
                      >
                        Area Guides
                      </Link>
                    </NavItem>
                    <NavItem className="uk-nav-divider"></NavItem>
                    <NavItem>
                      <Link
                        onClick={() => {
                          UIkit.dropdown("#guide-dropdown").hide(0);
                        }}
                        to="/property-field-values"
                      >
                        Property Field Values
                      </Link>
                    </NavItem>
                    <NavItem className="uk-nav-divider"></NavItem>
                    <NavItem>
                      <Link
                        onClick={() => {
                          UIkit.dropdown("#guide-dropdown").hide(0);
                        }}
                        to="/subscriptions"
                      >
                        Subscriptions
                      </Link>
                    </NavItem>
                  </NavbarDropdown>
                </NavItem>
                
              </Navbar>
            )}
            {!!account && (
              <Navbar right>
                {account?.details?.type === "onboarding" && (
                  <NavItem className={isActive(["/getting-started"])}>
                    <Link
                      to="/getting-started"
                      uk-tooltip="Get Started"
                      rel="noopener noreferrer"
                    >
                      <Image
                        src="/images/getting-started.svg"
                        className="margin-zero"
                      />
                    </Link>
                  </NavItem>
                )}
                <NavItem className={isActive(["/ai-compose"])}>
                  <Link
                    to="/ai-assistant"
                    uk-tooltip="AI Assistant"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <Image
                      src="/images/ai-assistant-nav.svg"
                      className="margin-zero"
                    />
                  </Link>
                </NavItem>
                <NavItem>
                  <Link
                    to="#"
                    uk-toggle="target: #modal-notifications"
                    uk-tooltip="Notifications"
                    className="hms-notification-badge"
                  >
                    <Image
                      src="/images/announcement.svg"
                      className="margin-zero"
                    />
                    {account.announcements?.length > 0 && (
                      <Badge
                        className="hms-notification-count"
                        count={account.announcements.length}
                      />
                    )}
                  </Link>
                </NavItem>
                <NavItem className={isActive(["/reports/"])}>
                  <Link to="/reports" uk-tooltip="Reports">
                    <Image src="/images/reports.svg" className="margin-zero" />
                  </Link>
                </NavItem>
                <NavItem
                  className={isActive([
                    "/team",
                    "/zones",
                    "/settings",
                    "/billing",
                    "/payments",
                  ])}
                >
                  <Link to="#">
                    <Image src="/images/settings.svg" className="margin-zero" />
                  </Link>

                  <NavbarDropdown id="more-dropdown">
                    <NavItem>
                      <Link to="/units">Units</Link>
                    </NavItem>
                    <NavItem>
                      <Link to="/macros">Macros</Link>
                    </NavItem>

                    <NavItem className="uk-nav-divider"></NavItem>
                    <NavItem>
                      <Link to="/chatbot-faqs">AI Chatbot FAQs</Link>
                    </NavItem>
                    <NavItem>
                      <Link to="/unanswered-questions">AI Chatbot Unanswered Questions</Link>
                    </NavItem>

                    <NavItem className="uk-nav-divider"></NavItem>

                    <NavItem>
                      <Link to="/settings">Settings</Link>
                    </NavItem>

                    {!+account?.user?.owner_id && [
                      <NavItem key="team-link">
                        <Link to="/team">Users</Link>
                      </NavItem>,
                      <NavItem key="user-group-link">
                        <Link to="/zones">Zones</Link>
                      </NavItem>,
                    ]}
                    {!+account?.user?.owner_id && (
                      <NavItem>
                        <Link
                          onClick={() => {
                            UIkit.dropdown("#profile-dropdown").hide(0);
                          }}
                          to="/billing"
                        >
                          Billing
                        </Link>
                      </NavItem>
                    )}
                    {!+account?.user?.owner_id && hasExtras() && (
                      <NavItem>
                        <Link
                          onClick={() => {
                            UIkit.dropdown("#profile-dropdown").hide(0);
                          }}
                          to="/payments"
                        >
                          Payments
                        </Link>
                      </NavItem>
                    )}
                  </NavbarDropdown>
                </NavItem>
                <NavItem className={isActive(["/profile"])}>
                  <Link to="#">
                    <img
                      src={profileImage?.url || "/images/profile.svg"}
                      className="nav-profile-avatar"
                      alt="Profile"
                    />
                  </Link>
                  <NavbarDropdown id="profile-dropdown">
                    <NavItem>
                      <Link
                        onClick={() => {
                          UIkit.dropdown("#profile-dropdown").hide(0);
                        }}
                        to="/profile"
                      >
                        Profile
                      </Link>
                    </NavItem>
                    <NavItem>
                      <a
                        href="https://intercom.help/ruebarueapp/en/"
                        target="_blank"
                        rel="noreferrer"
                      >
                        Knowledge Base
                      </a>
                    </NavItem>
                    <NavItem>
                      <Link to="#" onClick={handleLogout}>
                        Sign Out
                      </Link>
                    </NavItem>
                  </NavbarDropdown>
                </NavItem>
              </Navbar>
            )}
          </div>
          <div id="mobile-menu" uk-offcanvas="overlay: true">
            <div className="uk-offcanvas-bar">
              <button
                className="uk-offcanvas-close responsive-menu-close"
                type="button"
                uk-close
              >
                <Image src="/images/close-small.svg" alt="logo" />
              </button>
              <ul className="uk-nav uk-nav-primary uk-margin-auto-vertical responsive-outer-menu">
                <li>
                  <a href="/messages">Messages</a>
                </li>
                <li>
                  <a href="/guests">Guests</a>
                </li>
                <li>
                  <a href="/contacts">Contacts</a>
                </li>
                <li>
                  <a href="/orders">Orders</a>
                </li>
              {/*
                <li>
                  <a href="/extend-guest-stay">Extend Stays</a>
                </li>
               */}  
                <li className="uk-nav-header">Manage</li>
                <ul className="uk-nav uk-nav-primary uk-margin-auto-vertical responsive-inner-menu">
                  <li>
                    <a href="/units">Units</a>
                  </li>
                  <li>
                    <a href="/macros">Macros</a>
                  </li>
                  <li>
                    <a href="/macros">AI Chatbot FAQs</a>
                  </li>
                  <li>
                    <a href="/macros">AI Chatbot Unanswered Questions</a>
                  </li>
                  {/*
                  <li>
                    <Link to="/support-hub">Support Hub</Link>
                  </li>
                   */}
                </ul>
                <li className="uk-nav-header">Guest Guides</li>
                <ul className="uk-nav uk-nav-primary uk-margin-auto-vertical responsive-inner-menu">
                  <li>
                    <a href="/master-home-guide">Master Home Guides</a>
                  </li>
                  <li>
                    <a href="/properties">Home Guides</a>
                  </li>
                  <li>
                    <a href="/extras">Extras Guide</a>
                  </li>
                  <li>
                    <a href="/areas">Area Guides</a>
                  </li>
                  <li>
                    <a href="/property-field-values">Property Field Values</a>
                  </li>
                  <li>
                    <a href="/subscriptions">Subscriptions</a>
                  </li>
                </ul>
                <li className="uk-nav-header">Messaging</li>
                <ul className="uk-nav uk-nav-primary uk-margin-auto-vertical responsive-inner-menu">
                  <li>
                    <a href="/scheduler">Scheduler</a>
                  </li>
                  <li>
                    <a href="/alerts">Alerts</a>
                  </li>
                  <li>
                    <a href="/surveys">Surveys</a>
                  </li>
                  <li>
                    <a href="/saved-responses">Saved Responses</a>
                  </li>
                  <li>
                    <a href="/message-templates">Message Templates</a>
                  </li>
                </ul>
                <li className="uk-nav-header">Operations</li>
                <ul className="uk-nav uk-nav-primary uk-margin-auto-vertical responsive-inner-menu">
                  <li>
                    <a href="/operations">Dashboard</a>
                  </li>
                  {FEATURES.CALENDAR_ENABLED && (
                  <li>
                    <a href="/operations/calender">Calender</a>
                  </li>
                  )}
                  {FEATURES.HOUSEKEEPING_ENABLED && (
                  <li>
                    <a href="/operations/housekeeping">Housekeeping</a>
                  </li>
                  )}
                  {FEATURES.INSPECTIONS_ENABLED && (
                  <li>
                    <a href="/operations/inspections">Inspections</a>
                  </li>
                  )}
                  {FEATURES.MAINTENANCE_ENABLED && (
                  <li>
                    <a href="/operations/maintenance">Maintenance</a>
                  </li>
                  )}
                  <li>
                    <a href="/work-orders">Work Orders</a>
                  </li>
                  {FEATURES.RULES_ENABLED && (
                  <li>
                    <a href="/operations/rules">Rules</a>
                  </li>
                  )}
                  {FEATURES.STORAGE_LOCATIONS_ENABLED && (
                  <li>
                    <a href="/operations/storage/locations">Storage Locations</a>
                  </li>
                  )}
                  {FEATURES.STORAGE_ITEMS_ENABLED && (
                  <li>
                    <a href="/operations/storage/items">Storage Items</a>
                  </li>
                  )}
                  {FEATURES.MANAGE_STOCK_ENABLED && (
                  <li>
                    <a href="/operations/storage/stock">Manage Stock</a>
                  </li>
                  )}
                  {FEATURES.STOCK_MOVEMENTS_ENABLED && (
                  <li>
                    <a href="/operations/storage/movements">Stock Movements</a>
                  </li>
                  )}
                  {FEATURES.HOME_INVENTORY_ENABLED && (
                  <li>
                    <a href="/operations/home-inventory">Home Inventory</a>
                  </li>
                  )}
                  {FEATURES.CLEANING_STANDARDS_ENABLED && (
                  <li>
                    <a href="/operations/standards-structure">Cleaning & Inspection Standards</a>
                  </li>
                  )}
                  {FEATURES.PROPERTY_SETUP_ENABLED && (
                  <li>
                    <a href="/operations/property-setup">Property Setup</a>
                  </li>
                  )}
                  {FEATURES.CHECKLISTS_ENABLED && (
                  <li>
                    <a href="/operations/checklists">Checklists</a>
                  </li>
                  )}
                </ul>
                <li>
                  <a href="/reports">Reports</a>
                </li>
                <li>
                  <a href="/notes">Notes</a>
                </li>
                {!+account?.user?.owner_id && [
                  <li>
                    <a href="/team">Users</a>
                  </li>,
                  <li>
                    <a href="/zones">Zones</a>
                  </li>,
                ]}
                <li>
                  <a href="/settings">Settings</a>
                </li>
                <li>
                  <a href="/billing">Billing</a>
                </li>
                <li>
                  <a href="/profile">Profile</a>
                </li>
                <li>
                  <a
                    href="https://intercom.help/ruebarueapp/en/"
                    target="_blank"
                  >
                    Knowledge Base
                  </a>
                </li>
                <li>
                  <a href="#" onClick={handleLogout}>
                    Sign Out
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </NavbarContainer>
      </NavbarSticky>
      <TrialAccount />
      <Notification />
    </>
  );
};

export default Header;
